import _ from "lodash";

function getOrCreateRow(rowsByStoreId, store) {
    if (!rowsByStoreId.has(store.storeId)) {
        rowsByStoreId.set(store.storeId, {
            storeId: store.storeId,
            storeName: store.storeName,
            closedDate: undefined,
            cells: new Map()
        });
    }
    return rowsByStoreId.get(store.storeId);
}

function getOrCreateCell(row, date) {
    if (!row.cells.has(date)) {
        row.cells.set(date, {});
    }
    return row.cells.get(date);
}

function getCleansedFooterTotals(salesStores, measureKey) {
    const footerTotals = new Map();
    salesStores.forEach(store => store.weekEndData
        .filter(weekEndData => weekEndData[measureKey] !== undefined)
        .forEach(weekEndData => footerTotals.set(weekEndData.date, (footerTotals.get(weekEndData.date) || 0) + weekEndData[measureKey])));
    return footerTotals;
}

export function buildStoreTotalsModel(data, includeFillOnly, measureKey) {
    const rowsByStoreId = new Map();

    data.sales.stores.forEach(store => {
        const row = getOrCreateRow(rowsByStoreId, store);
        store.weekEndData.forEach(weekEndData => {
            const cell = getOrCreateCell(row, weekEndData.date);
            if (!cell.cleansed) {
                cell.cleansed = weekEndData;
            }
        });
    });

    data.stores.forEach(store => {
        getOrCreateRow(rowsByStoreId, store).closedDate = store.closedDate;
    });

    data.fill.stores.forEach(store => {
        const row = getOrCreateRow(rowsByStoreId, store);
        store.weekEndData.forEach(weekEndData => {
            getOrCreateCell(row, weekEndData.date).fill = weekEndData;
        });
    });

    const salesRollUpDates = includeFillOnly ? data.fill.weekEndDates : data.sales.rollUpDates;
    const fillRollUpDates = includeFillOnly ? data.fill.weekEndDates : data.fill.rollUpDates;
    const expectedDates = _.union(salesRollUpDates, fillRollUpDates);
    const columnDates = _.union(expectedDates, data.sales.weekEndDates, data.fill.weekEndDates).sort().reverse();
    const rows = [...rowsByStoreId.values()];

    return {
        rows,
        storeIds: rows.map(row => row.storeId),
        expectedDates,
        columnDates,
        footerTotals: getCleansedFooterTotals(data.sales.stores, measureKey)
    };
}
